import React, { useEffect, useState } from "react"
import NavbarEntry from "./NavbarEntry"
import { getAssignments } from "src/sites/myassignments/myassignments"
import { useInterval } from "src/utils/useInterval"

export const MyAssignmentsEntry = ({ open, onNavigate }: { open: boolean; onNavigate?: () => void }) => {
  const [assignmentCount, setAssignmentCount] = useState<number>(0)

  const fetchData = async () => {
    if (document.visibilityState == "hidden") return
    const { totalCount } = await getAssignments(0, 0)
    setAssignmentCount(totalCount)
  }

  useEffect(() => { fetchData() }, [])
  useInterval(fetchData, 10000)
  
  return (
    <NavbarEntry
      open={open}
      key="assignments"
      iconPath={
        assignmentCount > 0
          ? "/exfluency/portal-icon_open-assignments-bell.svg"
          : "/exfluency/portal-icon_open-assignments.svg"
      }
      label="Open Assignments"
      path="/assignments"
      data-testid={`menu-assignments-button`}
      onNavigate={onNavigate}
    />
  )
}
